export interface IModel {
  // i18n: I18nLocalizer;
  renderComponent?: () => React.ReactNode;
}

export abstract class BaseModel implements IModel {
  // i18n: I18nLocalizer = createDefaultI18nLocalizer();
}
